import { useState } from 'react';
import { toast } from 'sonner';

import { useRosService } from 'hooks/ros';
import { useEmergencyStopState } from 'hooks/statekeeping';

export function useEmergencyStop() {
  const { RosServices } = useRosService();
  const { data, setEmergencyStop } = useEmergencyStopState();
  const [loading, setLoading] = useState(false);

  const isEmergencyStop = data.softwareStopped;
  const isHardwareStopped = data.hardwareStopped;

  async function sendEmergencyStop() {
    setLoading(true);
    try {
      if (!isEmergencyStop) {
        const { success, message } = await RosServices.eStopTrigger();
        if (success) {
          toast.success('Emergency stop triggered', { description: message });
          setEmergencyStop(true);
        } else {
          toast.error('Error triggering emergency stop', { description: message });
        }
      } else {
        const { success, message } = await RosServices.eStopRelease();
        if (success) {
          toast.success('Emergency stop released', { description: message });
          setEmergencyStop(false);
        } else {
          toast.error('Error releasing emergency stop', { description: message });
        }
      }
    } finally {
      setLoading(false);
    }
  }

  return { isEmergencyStop, sendEmergencyStop, loading, isHardwareStopped };
}
